
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.682","y":".582","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M13.535 17.436a.5.5 0 000-.707l-3.182-3.182a.5.5 0 10-.707.707l2.829 2.828-2.829 2.828a.5.5 0 10.707.708l3.182-3.182zM.828 16.729a.5.5 0 000 .707l3.182 3.182a.5.5 0 00.707-.707L1.89 17.081l2.828-2.828a.5.5 0 10-.707-.707L.828 16.727zm12.354-.147h-12v1h12v-1z","fill":"currentColor"}})])
          )
        }
      }
    